if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector('details');

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        if (this.mainDetailsToggle) this.mainDetailsToggle.setAttribute('hidden', '');
        if (this.elements.shareButton) {
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
        }
      }
      else {
        if (this.mainDetailsToggle) {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          const inputBtn = this.mainDetailsToggle.querySelector('.share-button__input');
          if (inputBtn) inputBtn.addEventListener('click', this.copyToClipboard.bind(this));
          const copyBtn = this.mainDetailsToggle.querySelector('.share-button__copy');
          if (copyBtn) copyBtn.addEventListener('click', this.copyToClipboard.bind(this));
          const closeBtn = this.mainDetailsToggle.querySelector('.share-button__close');
          if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
        }
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.shareSummary.focus();
      }
      else {
        setTimeout(() => {
          this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
          document.body.addEventListener('click', this.onBodyClickEvent);
        });
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
      });
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  });
}
